const THINK_OPEN = "<think>";

interface PromptTurn {
  role: "user" | "assistant";
  content: string;
}

const BASE_CHAT_INSTRUCTION =
  "You are a concise coding assistant. Answer directly in Markdown. Do not show hidden reasoning. Prefer short, executable answers.";

export function buildBaseChatPrompt(turns: PromptTurn[], editorContext: string): string {
  const parts = [BASE_CHAT_INSTRUCTION];
  if (editorContext) {
    parts.push(`Current Python editor context:\n\n\`\`\`python\n${editorContext.slice(-3_000)}\n\`\`\``);
  }
  for (const turn of turns.slice(-4)) {
    const label = turn.role === "user" ? "User" : "Assistant";
    parts.push(`${label}: ${turn.content.slice(-1_500)}`);
  }
  parts.push("Assistant:");
  return parts.join("\n\n");
}

/**
 * Return only user-visible answer text while a response is still streaming.
 * Qwen variants can emit thinking tags even when thinking is disabled. This
 * deliberately hides both complete and not-yet-closed thinking blocks.
 */
export function visibleChatText(raw: string): string {
  let visible = raw.replace(/<think>[\s\S]*?<\/think>/gi, "");
  visible = visible.replace(/<think>[\s\S]*$/gi, "");
  visible = visible.replace(/<\/?think>/gi, "");

  const lower = visible.toLowerCase();
  for (let length = THINK_OPEN.length - 1; length > 0; length -= 1) {
    if (lower.endsWith(THINK_OPEN.slice(0, length))) {
      visible = visible.slice(0, -length);
      break;
    }
  }

  return visible.replace(/^\s+/, "");
}
